import { defaultTheme } from 'react-admin';
import { createTheme } from '@mui/material/styles';

// Create a theme instance with Fortress brand colors
export const theme = createTheme({
    ...defaultTheme,
    palette: {
        primary: {
            main: '#1C5195', // Fortress primary blue
            dark: '#164279',
            light: '#4478B4',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#1C302E', // Secondary color from the logo
            dark: '#0D1A18',
            light: '#344645',
            contrastText: '#FFFFFF',
        },
        background: {
            default: '#F5F7FA',
        },
        grey: {
            100: '#F5F7FA',
            200: '#EAECF0',
        },
        text: {
            primary: '#333333',
            secondary: '#666666',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h6: {
            fontWeight: 600,
        },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    backgroundColor: '#1C5195',
                    '&:hover': {
                        backgroundColor: '#164279',
                    },
                },
                root: {
                    textTransform: 'none',
                    borderRadius: '8px',
                    fontSize: '13px',
                }
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: '#1C5195',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#FFFFFF',
                    borderRadius: '0 16px 16px 0',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                    border: 'none',
                    // Ensure content doesn't overflow the rounded corners
                    overflow: 'hidden',
                    // Add some margin to separate from the edge of the screen
                    marginLeft: '8px',
                    marginTop: '8px',
                    marginBottom: '8px',
                    height: 'calc(100% - 16px)',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&.RaMenuItemLink-active': {
                        borderLeft: '3px solid #1C5195',
                        backgroundColor: 'rgba(28, 81, 149, 0.08)',
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(28, 81, 149, 0.04)',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.03)',
                },
                elevation1: {
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.03)',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 600,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    overflow: 'hidden',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '6px',
                },
            },
        },
    },
}); 